export default __webpack_public_path__ + "static/anamorphicTypography-6a0c188c37760e6d6e2cbdd77c6eaaa5.png";